import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function Terms() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-emerald-50">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Button variant="outline" onClick={() => navigate('/')} className="mb-8">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Ana Sayfaya Dön
        </Button>

        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-slate-800 mb-6">Kullanım Koşulları</h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-lg text-slate-600 mb-6">
              <strong>Son Güncelleme:</strong> {new Date().toLocaleDateString('tr-TR')}
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">1. Hizmet Tanımı</h2>
            <p className="text-slate-700 mb-4">
              Mizaç360, bilimsel temelli mizaç değerlendirmesi ve AI destekli kişisel gelişim koçluğu sunan bir platformdur.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">2. Kullanıcı Sorumlulukları</h2>
            <ul className="list-disc list-inside text-slate-700 space-y-2 mb-4">
              <li>Doğru ve güncel bilgiler sağlamak</li>
              <li>Hesap güvenliğini korumak</li>
              <li>Platformu yasalara uygun kullanmak</li>
              <li>Diğer kullanıcıların haklarına saygı göstermek</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">3. Fikri Mülkiyet</h2>
            <p className="text-slate-700 mb-4">
              Platform içeriği, raporlar ve AI koçluk verileri Mizaç360'ın fikri mülkiyetidir.
              İzinsiz kullanım, kopyalama veya dağıtım yasaktır.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">4. Sorumluluk Sınırlaması</h2>
            <p className="text-slate-700 mb-4">
              Mizaç360, bir eğitim ve rehberlik platformudur. Sunulan değerlendirmeler ve öneriler 
              klinik tanı veya tedavi yerine geçmez. Tıbbi veya psikolojik sorunlar için mutlaka 
              uzman desteği alınmalıdır.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">5. Değişiklikler</h2>
            <p className="text-slate-700 mb-4">
              Mizaç360, kullanım koşullarını değiştirme hakkını saklı tutar. Değişiklikler 
              platform üzerinden duyurulacaktır.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}